var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive" },
        [
          _c("hr"),
          _vm._v(" "),
          !!_vm.busingDetails.TRANSPORTATION_STATUS_DESC
            ? _c("h5", [
                _c("strong", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.BusingDetails.bussingStatusWithColon"
                        )
                      )
                  ),
                  _c("br")
                ]),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.busingDetails.TRANSPORTATION_STATUS_DESC) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          !!_vm.busingDetails.BUS_NOTES
            ? _c("h5", [
                _c("strong", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.BusingDetails.bussingNotesWithColon"
                        )
                      )
                  ),
                  _c("br")
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.busingDetails.BUS_NOTES) }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.busPeriods.length > 0
            ? _vm._l(_vm.busPeriods, function(period, idx) {
                return _c(
                  "table",
                  {
                    key: period + "_" + idx,
                    staticClass: "table table-bordered"
                  },
                  [
                    _c("thead", [
                      _c("tr", { staticClass: "active" }, [
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.BusingDetails.busWithColon",
                                { period: period }
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.BusingDetails.stopWithColon")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.BusingDetails.timeWithColon")
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(3, function(index) {
                          return [
                            !!_vm.busingDetails[
                              period + "_BUS_NUMBER_" + index
                            ] ||
                            !!_vm.busingDetails[
                              period + "_STOP_LOCATION_" + index
                            ] ||
                            !!_vm.busingDetails[period + "_STOP_TIME_" + index]
                              ? _c("tr", { key: index }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.busingDetails[
                                            period + "_BUS_NUMBER_" + index
                                          ]
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.busingDetails[
                                            period + "_STOP_LOCATION_" + index
                                          ]
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("time")(
                                            _vm.busingDetails[
                                              period + "_STOP_TIME_" + index
                                            ]
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      !!_vm.busingDetails.PARKING_PERMIT ||
      !!_vm.busingDetails.PARKING_PERMIT_LOCATION
        ? _c("div", [
            _c("hr"),
            _vm._v(" "),
            _c("h5", [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.BusingDetails.parkingInformationWithColon"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              !!_vm.busingDetails.PARKING_PERMIT
                ? _c("div", { staticClass: "col-sm-4" }, [
                    _c("strong", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.BusingDetails.permitWithColon")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.busingDetails.PARKING_PERMIT) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.busingDetails.PARKING_PERMIT_LOCATION
                ? _c("div", { staticClass: "col-sm-4" }, [
                    _c("strong", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentInformation.locationWithColon"
                            )
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.busingDetails.PARKING_PERMIT_LOCATION) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.hasCarInformation()
        ? [
            _c("hr"),
            _vm._v(" "),
            _c("h5", [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.BusingDetails.carInformationWithColon")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _vm.firstRowCarInformation()
              ? _c("div", { staticClass: "row" }, [
                  !!_vm.busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID
                    ? _c("div", { staticClass: "col-sm-4" }, [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.BusingDetails.licensePlateWithColon"
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.busingDetails.PARKING_PERMIT_LICENSE_PLATE_ID
                            ) +
                            "\n\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.busingDetails.PARKING_PERMIT_MAKE_MODEL
                    ? _c("div", { staticClass: "col-sm-4" }, [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.BusingDetails.makeSlashModelWithColon"
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.busingDetails.PARKING_PERMIT_MAKE_MODEL
                            ) +
                            "\n\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.busingDetails.PARKING_PERMIT_CAR_COLOR
                    ? _c("div", { staticClass: "col-sm-4" }, [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.BusingDetails.carColorWithColon"
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.busingDetails.PARKING_PERMIT_CAR_COLOR) +
                            "\n\t\t\t"
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.secondRowCarInformation()
              ? _c("div", { staticClass: "row" }, [
                  !!_vm.busingDetails.TRANS_STREET
                    ? _c(
                        "div",
                        {
                          class: {
                            "col-sm-3": _vm.colSize("carInfo"),
                            "col-sm-4": !_vm.colSize("carInfo")
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.BusingDetails.streetWithColon"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.busingDetails.TRANS_STREET) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.busingDetails.TRANS_BLOCK
                    ? _c(
                        "div",
                        {
                          class: {
                            "col-sm-3": _vm.colSize("carInfo"),
                            "col-sm-4": !_vm.colSize("carInfo")
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.BusingDetails.blockWithColon"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.busingDetails.TRANS_BLOCK) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.busingDetails.TRANS_ZONE
                    ? _c(
                        "div",
                        {
                          class: {
                            "col-sm-3": _vm.colSize("carInfo"),
                            "col-sm-4": !_vm.colSize("carInfo")
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.BusingDetails.zoneWithColon"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.busingDetails.TRANS_ZONE) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.busingDetails.TRANS_NOTES
                    ? _c(
                        "div",
                        {
                          class: {
                            "col-sm-3": _vm.colSize("carInfo"),
                            "col-sm-4": !_vm.colSize("carInfo")
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.BusingDetails.carNotesWithColon"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.busingDetails.TRANS_NOTES)
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }